<div class="insight-container">

    <div class="report-menu">
        <div class="report-title-with-actions">
            <div class="report-name">
                Analytics Report - Public Portal Visits
            </div>

            <div class="report-menu__actions">
                <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                                   [active]="showingFilterBar"
                                   (toggled)="toggleFilter()"
                ></app-filter-button>

                <button
                        mat-icon-button
                        class="report-button"
                        (click)="closeInsight()"
                        [matTooltip]="'Close'"
                >
                    <mat-icon class="action-icon">close</mat-icon>
                </button>
            </div>
        </div>

        <div class="report-subtitle">
            Public portal visits
        </div>
    </div>

    <app-filter-bar
            class="report-menu__filters"
            [origin]="'analyticsReport'"
            [showingFilterBar]="showingFilterBar"
            [useDateFilter]="true"
            [useVehicleFilter]="false"
            [useDriverFilter]="false"
            [useVehicleGroupFilter]="false"
            [defaultDateFilter]="TimeRangeFilter.PAST_90_DAYS"
            (dateFilterChanged)="dateFilterChanged($event)"
            (appliedFiltersChanged)="appliedFiltersCount = $event"
    >
    </app-filter-bar>

    <div class="report__table__wrapper"
         [ngClass]="{'report-table-with-filter-bar': showingFilterBar}">

        <app-analytics-report-view [dateFrom]="dateFilter()?.from"
                                   [dateTo]="dateFilter()?.to"></app-analytics-report-view>

    </div>
</div>
